import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { WysiwygField, Container } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphProjectsHighlighted as Type } from '../../../types/uncinc_profile/paragraphs';
import { ButtonWrapper } from '../../../components';

import './style.scss';

interface ParagraphProjectsHighlightedProps
  extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphProjectsHighlighted: React.FC<ParagraphProjectsHighlightedProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.value;
  const link = paragraph.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const linkTarget = link?.options?.attributes?.target;

  return (
    <div className="Paragraph ParagraphProjectsHighlighted">
      <Container>
        <div className="row">
          <div className="col-12 col-lg-8">
            {/* Title */}
            {title && <h2>{title}</h2>}

            {/* Body */}
            {(body || link) && (
              <div className="ParagraphProjectsHighlighted__content">
                {body && (
                  <WysiwygField
                    html={body}
                    className="ParagraphProjectsHighlighted__body"
                  />
                )}

                {/* Action */}
                {linkUrl && (
                  <ButtonWrapper
                    href={linkUrl}
                    target={linkTarget}
                  >
                    {linkTitle}
                  </ButtonWrapper>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {/* View data */}
            <View
              id="projects_filtered"
              display="highlighted"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphProjectsHighlighted;
